import { PotentialConflictsCtrl } from './potential-conflicts.controller';

export const PotentialConflictsComponent = {
  controller: PotentialConflictsCtrl,
  bindings: {
    prevStep: '&',
  },
  template: require('./potential-conflicts.html'),
};
